import React, { useEffect, useState, useRef } from "react";
import logo from "../../../../icons/gymx-final-black.png";
import { useNavigate, useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { IoMdPrint } from "react-icons/io";
import { IoArrowBack } from "react-icons/io5";
import dayjs from "dayjs";
import { encodedImagesURI } from '../../../../utils/helpers'
import BankVoucherLayout from '../../../../base-components/BankVoucherLayout';

const Receipts = () => {
  const [family_members, setFamilyMembers] = useState([]);
  const [voucher, setVoucher] = useState();
  const [member, setMember] = useState();
  const [member_package_amount, setMemberPackageAmount] = useState(0);
  const [role, setRole] = useState("");
  const [loading, setLoading] = useState(true);
  const [member_id, setMemberID] = useState("");
  const [location_id, setLocationID] = useState("");
  const [company_id, setCompanyID] = useState("");
  const [packages, setPackages] = useState([]);
  const printRef = useRef()
  const reactToPrintFn = useReactToPrint({ contentRef: printRef });
  const [companyDetails, setCompanyDetails] = useState({});

  const getCompanyDataById = async () => {
    try {
      const res = await fetch(BASE_URL + `company/${company_id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = await res.json();
      console.log('Company Data Response:', data);
      setCompanyDetails(data);
    } catch (error) {
      console.error('Error fetching company data:', error);
    }
  }

  const { id } = useParams();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  useEffect(() => {
    const sessionStr = sessionStorage.getItem("user-info");
    if (sessionStr) {
      const session = JSON.parse(sessionStr);
      setRole(session.user.role);
      setCompanyID(session.user.company_id);
      setLocationID(session.user.location_id);
      setMemberID(session.user.member_id);
    } else {
      navigate("/login");
    }
  }, []);
  console.log("idd", id);
  useEffect(() => {
    if (role) {
      getVoucherById();
      getAllPackages();
      if (company_id) getCompanyDataById();
    }
  }, [role]);

  function getVoucherById() {
    fetch(BASE_URL + `voucher/getVoucherById/${id}`)
      .then((response) => response.json())
      .then((data) => {
        setVoucher(data.voucher);
        getMemberByID(data.voucher.member_id._id);
      })
      .catch((error) => console.log(error));
  }

  function getMemberByID(id) {
    fetch(BASE_URL + `members/get-member/${id}`)
      .then((response) => response.json())
      .then((data) => {
        setMember(data.member);
        getMemberPackage(data.member.package_id);
        // getFamilyMembers(data.member._id)
      })
      .catch((error) => console.log(error));
  }


  function getAllPackages() {
    fetch(BASE_URL + `package/getPackages`)
      .then((response) => response.json())
      .then((data) => {
        setPackages(data.packages);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  function getMemberPackage(id) {
    fetch(BASE_URL + `package/getPackageById/${id}`)
      .then((response) => response.json())
      .then((data) => {
        setMemberPackageAmount(data.packages);
        setLoading(false);
      })
      .catch((error) => console.log(error));
  }

  const handleNavigate = (id) => {
    navigate(`/vouchers/${voucher?.
      subscription_id.
      _id}`);
  };

  return (
    <div ref={printRef} className="max-w-xl mx-auto bg-white p-6 mt-5 print:p-0 print:m-0 h-screen print:h-auto">
      {/* Action Buttons Bar */}
      <div className="flex justify-between items-center p-2 print:hidden mb-4">
        <div className='px-2 py-2'>
          <IoArrowBack onClick={handleNavigate}
            className="cursor-pointer text-4xl print:hidden" />
        </div>
        <div>
          <IoMdPrint className='text-2xl hover:cursor-pointer md:text-4xl lg:text-4xl text-black print:hidden' onClick={() => reactToPrintFn()} />
        </div>
      </div>
      <BankVoucherLayout
        company_id={company_id}
        voucherData={{
          invoice_no: voucher?.invoice_no,
          voucher_no: voucher?.invoice_no,
          voucher_type: 'RECEIPT',
          voucher_date: voucher?.voucher_date,
          due_date: voucher?.voucher_date,
          membership_fee: voucher?.receipt?.amount, // Showing receipt amount as membership/main fee
          discount: 0,
          other_charges_amount: 0,
          registration_fee: 0,
          trainer_fee: 0,
          facilities_fee: 0,
          is_paid: true,
          payment_status: 'Paid',
          payment_date: voucher?.voucher_date,
          reference_number: voucher?.reference_number,
          payment_method: voucher?.payment_method
        }}
        companyData={companyDetails}
        memberData={{
          member_id: member?.member_id,
          name: member?.name,
          phone: member?.phone,
          package_name: member_package_amount?.title
        }}
      >
        <div className="flex justify-center items-center mb-4">
          <img
            src={companyDetails && companyDetails?.company_logo ? encodedImagesURI(companyDetails?.company_logo) : logo}
            className="text-2xl font-bold text-center text-gx-ink"
            style={{ maxWidth: "150px", maxHeight: "150px", objectFit: "contain" }}
          />
        </div>
        <h2 className="text-2xl font-bold text-center text-gx-ink mb-4 print:text-large">
          Receipt
        </h2>

        <div className="max-w-xl mx-auto bg-white p-6 mt-5">
          <div className="grid grid-cols-1 sm:grid-cols-2 text-gx-ink">
            <div>
              <p className="text-sm print:text-lg">
                <strong>Receipt no: </strong> {voucher?.invoice_no}
              </p>
              {voucher?.company_has_bank_integration === true && (
                <p className="text-sm print:text-lg">
                  <strong>Bank Voucher Number: </strong>
                  {voucher?.transaction_number || 'N/A'}
                </p>
              )}
              <p className="text-sm print:text-lg">
                <strong>Receipt Date: </strong>{" "}
                {voucher?.voucher_date
                  ? dayjs(voucher.voucher_date).format("MMM DD, YYYY")
                  : ''}
              </p>
              <p className="text-sm print:text-lg">
                <strong>Company: </strong>
                {member?.company_id?.company_name}
              </p>
              <p className="text-sm print:text-lg">
                <strong>Company Contact No: </strong> {member?.location_id?.phone_number}
              </p>
              <p className="text-sm print:text-lg">
                <strong>Address: </strong> {member?.address}
              </p>
              <p className="text-sm print:text-lg">
                <strong>Package Name: </strong> {member_package_amount.title}
              </p>
              <p className="text-sm print:text-lg">
                <strong>Package Duration: </strong> {member_package_amount?.duration}
              </p>
            </div>
            <div>

              <p className="text-sm print:text-lg">
                <strong>Member Name: </strong>
                {member?.name}
              </p>
              <p className="text-sm print:text-lg">
                <strong>Member ID: </strong>
                {member?.member_id}
              </p>
              <p className="text-sm print:text-lg">
                <strong>MemberEmail: </strong> {member?.email}
              </p>
              <p className="text-sm print:text-lg">
                <strong>Member Contact No: </strong>
                {member?.phone}
              </p>
              <p className="text-sm print:text-lg">
                <strong>Member Address: </strong>
                {member?.location_id?.address}
              </p>
            </div>
          </div>
        </div>

        <table className="w-full mt-4 border-collapse border border-gx-border">
          <thead>
            <tr className="bg-gx-canvas text-gx-ink">
              <th className="border border-gx-border px-2 py-1">Charges</th>
              <th className="border border-gx-border px-2 py-1">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr className="text-center text-gx-ink">
              <td className="border border-gx-border px-2 py-1">
                Advance Payment
              </td>
              <td className="border border-gx-border px-2 py-1">
                {voucher?.receipt?.amount}
              </td>
            </tr>
          </tbody>
        </table>

        <div className="mt-8 text-gx-ink flex justify-between items-center">
          <div>
            <p className="text-left text-md font-semibold">
              <strong>Payment Method:</strong> {voucher?.payment_method}
            </p>
            {
              voucher?.payment_method !== 'Cash' && (
                <p className="text-left text-md font-semibold">
                  <strong>Payment Reference:</strong> {voucher?.reference_number}
                </p>
              )
            }
          </div>
          <p className="text-right text-md font-semibold">
            <strong>Total:</strong> {voucher?.receipt?.amount}
          </p>
        </div>
      </BankVoucherLayout >
    </div >
  );
};
export default Receipts;
